import { Controller, useFormContext } from "react-hook-form";
import { Input, Switch } from "rizzui";

export interface ILandingPageConfigurationsProps {
  name: string;
}

export default function LandingPageConfigurations({
  name,
}: ILandingPageConfigurationsProps) {
  const { control } = useFormContext() || {};
  return (
    <div className="flex flex-col gap-2">
      <h6 className="text-foreground md:text-base">
        Landing Page Configuration
      </h6>
      <Controller
        control={control}
        name={`${name}.useProjectSgTrackingId`}
        render={({ field, fieldState, formState }) => (
          <Switch
            label="ProjectSG Tracking ID"
            size="lg"
            className="w-auto"
            {...field}
            checked={field.value || false}
            error={fieldState.error?.message}
          />
        )}
      />

      <Controller
        control={control}
        name={`${name}.limitCreation`}
        render={({ field, fieldState, formState }) => (
          <Input
            label="Limit Creation"
            className="max-w-[250px] w-auto"
            type="number"
            {...field}
            checked={field.value || false}
            error={fieldState.error?.message}
          />
        )}
      />
    </div>
  );
}
